import {SlAlert} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import {MicroConversionTrackingEventsEnum} from '../../common/trackingMicroconversion/Model/EventProductCustomizationEnum';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';
import customizationPricingOverviewComponentNew from './customizationPricingOverviewComponent';

export default class FinishingColorsComponent extends HTMLElement {
    private readonly refreshOverviewUI: customizationPricingOverviewComponentNew;
    private readonly config: ProductCustomizationConfigModel;
    private positionId: number | null = null;
    private autoSelectColorAlert: SlAlert | null = null;

    constructor() {
        super();

        this.refreshOverviewUI = notNull(document.querySelector<customizationPricingOverviewComponentNew>('#pricing-overview'));
        this.config = ProductCustomizationConfigModel.getInstance();
    }

    connectedCallback() {
        this.positionId = parseInt(this.dataset.posid!, 10);
        this.autoSelectColorAlert = notNull(this.querySelector<SlAlert>('sl-alert.auto-select-color')) as SlAlert;
        this.attachFinishingColorsEventListeners();
    }

    disconnectedCallback() {
        this.hideColorsSetAutomaticallyAlert();
        this.detachFinishingColorsEventListeners();
    }

    private handleItemClick = (event: MouseEvent) => {
        const selectedColor = (event.target as HTMLElement).closest('.item') as HTMLDivElement;

        this.setCurrentNumberOfMotifColors(selectedColor);
    };

    private attachFinishingColorsEventListeners(): void {
        let colorItems = this.querySelectorAll<HTMLDivElement>('.item');
        const selectedMountingPositionItem = notNull(
            document.querySelector<HTMLDivElement>(`clx-customization-mounting-position .positions .item[data-posid="${this.positionId}"]`),
        );
        const finishingColorTextOfSelectedMountingPositionItem = notNull(
            selectedMountingPositionItem.querySelector<HTMLDivElement>('.display-finishing-color'),
        );

        colorItems.forEach((item) => {
            item.addEventListener('click', this.handleItemClick);

            if (item.classList.contains('active')) {
                const numberOfFinishingColors = notNull(item.querySelector<HTMLDivElement>('.number-of-colors-text'));
                finishingColorTextOfSelectedMountingPositionItem.innerText = numberOfFinishingColors.innerText;
                this.config.setAmountOfColors(notNull(this.positionId), parseInt(item.dataset.noc || '0', 10));
            }
        });
    }

    private detachFinishingColorsEventListeners(): void {
        let colorItems = this.querySelectorAll<HTMLDivElement>('.item');
        colorItems.forEach((item) => {
            item.removeEventListener('click', this.handleItemClick);
        });
    }

    public async setNumberOfMotifColorsFromTajimaApiResult(numberOfMotifColors: number): Promise<void> {
        let newNumberOfMotifColors = notNull(this.querySelector(`.item[data-noc="${numberOfMotifColors}"]`)) as HTMLDivElement;
        await this.setCurrentNumberOfMotifColors(newNumberOfMotifColors, true);

        this.querySelectorAll('.item:not(.active)').forEach((item) => {
            item.classList.add('inactive');
        });

        this.showColorsSetAutomaticallyAlert();
    }

    public async resetNumberOfMotifColors(): Promise<void> {
        this.hideColorsSetAutomaticallyAlert();

        let inactiveItems: NodeListOf<HTMLDivElement> = this.querySelectorAll('.item.inactive');
        inactiveItems.forEach((item) => {
            if (item.dataset.noc === '0') {
                return;
            }
            item.classList.remove('inactive');
        });

        let newNumberOfMotifColors = notNull(this.querySelector('.item[data-noc="1"]')) as HTMLDivElement;

        await this.setCurrentNumberOfMotifColors(newNumberOfMotifColors);
    }

    public showColorsSetAutomaticallyAlert(): void {
        this.autoSelectColorAlert?.show();
    }

    public hideColorsSetAutomaticallyAlert(): void {
        this.autoSelectColorAlert?.hide();
    }

    private async setCurrentNumberOfMotifColors(newNumberOfMotifColors: HTMLDivElement, setOtherOptionsInactive: boolean = false): Promise<void> {
        if (newNumberOfMotifColors.classList.contains('disabled')) {
            return;
        }

        const currentColor = this.querySelector<HTMLDivElement>('.item.active');
        if (currentColor) {
            currentColor.classList.remove('active');
            if (setOtherOptionsInactive) {
                currentColor.classList.add('inactive');
            }
        }

        this.config.setAmountOfColors(notNull(this.positionId), parseInt(newNumberOfMotifColors.dataset.noc!, 10));
        if (setOtherOptionsInactive) {
            newNumberOfMotifColors.classList.remove('inactive');
        }
        newNumberOfMotifColors.classList.add('active');
        this.updateNumberOfColorsInMountingPositionLabel(newNumberOfMotifColors);

        await this.refreshOverviewUI.refreshOverviewUIAndHandleErrors(this.config, MicroConversionTrackingEventsEnum.customization_configuration_change);
    }

    private updateNumberOfColorsInMountingPositionLabel(newNumberOfMotifColors: HTMLDivElement): void {
        let numberOfFinishingColors = notNull(newNumberOfMotifColors.querySelector<HTMLDivElement>('.number-of-colors-text'));

        let finishingColorTextOfSelectedMountingPositionItem = notNull(
            document.querySelector<HTMLDivElement>('clx-customization-mounting-position .positions .item.active .display-finishing-color'),
        );
        finishingColorTextOfSelectedMountingPositionItem.innerText = numberOfFinishingColors.innerText;
    }
}
if (!customElements.get('clx-customization-finishing-colors')) {
    customElements.define('clx-customization-finishing-colors', FinishingColorsComponent);
}
